/*
  Motor de fechas de entrega (PDP + carrito). La clase de material sale del prefijo del SKU
  (_can-, _pos-, _frm-, _pix-, _acr-, _kdc-). La lógica vive en window.DeliveryDateCalculator
  para reusarla fuera del PDP (carrito, #232). Asignación con guard para tolerar la
  re-inyección de scripts del theme editor (#223).

  Parámetros nacionales espejo del checkout (EDD manual, verificado ago-2026), que es la
  fuente de verdad:
  - Fulfillment "Same business day" con cutoff de mediodía (12:00) — fijo, Shopify no permite cambiarlo.
  - Perfil general (canvas/enmarcado/póster/kit): Express 1–2 días hábiles, GRATIS 3–5.
  - Perfil "PixSets" (creado 25-ago-2026, #301): Express 2–3 días hábiles, GRATIS 4–6. Aquí
    se modela como perfil general + 1 día hábil de producción (prodDays: 1): mismos extremos.
  - Perfil "Acrílicos personalizados": Express 8–9 días hábiles, GRATIS 10–12.
  El checkout muestra rangos; aquí se muestra el extremo TARDÍO del rango (sub-prometer):
  el cliente ve en el checkout una fecha igual o mejor que la del PDP/carrito, nunca peor.

  Entrega Local Día Siguiente (Monterrey, ago-2026): pedido a cualquier hora → llega el
  siguiente día hábil (can/pos/frm/kdc). PixSets: pedidos antes de las 12:00 entran al lote
  de impresión de esa tarde y llegan al día siguiente; después del corte o en día inhábil,
  al lote siguiente. Acrílicos: 10 días hábiles con el mismo corte de mediodía. Para la
  producción propia no hay cutoff público (el corte real de las 6am no se publicita).
*/
window.DeliveryDateCalculator = window.DeliveryDateCalculator || (function() {
  // Días festivos sin producción ni reparto, formato 'YYYY-MM-DD'. Sembrados los descansos
  // obligatorios de la LFT; agregar aquí cierres propios de la empresa/paquetería si los hay.
  // Re-sembrar el año siguiente cada diciembre (ver issue anual en GitHub).
  const HOLIDAYS = [
    '2026-09-16', // Independencia (miércoles)
    '2026-11-16', // Revolución (tercer lunes de noviembre)
    '2026-12-24', // Nochebuena: sin producción ni paqueterías (Daniel, oct-2026)
    '2026-12-25', // Navidad
    '2026-12-31', // Fin de año: sin producción ni paqueterías
    '2027-01-01', // Año Nuevo (para que los pedidos de fin de año calculen bien)
    '2027-02-01'  // Día de la Constitución (primer lunes de febrero)
  ];

  // Temporadas (#410): ventana en la que PDP, carrito y /pages/tiempos-de-entrega dicen si
  // el pedido llega a tiempo y hasta cuándo pedir. lastArrival = último día de entrega que
  // cuenta como "antes de": 23-dic (el 24 no hay reparto) y 5-ene (la mañana del 6 ya hay
  // regalo); 12-feb (viernes: sábado y domingo no hay reparto). showFrom = desde cuándo se
  // muestra: Navidad al terminar el Buen Fin; Reyes sólo cuando Navidad ya cerró; San Valentín
  // desde el 27-ene; nunca compiten por espacio. closures = frase de los días sin producción
  // ni reparto de la temporada, que pinta el bloque de /pages/tiempos-de-entrega. Los cortes
  // NO se escriben a mano: salen de compute()/computeLocal() con los festivos de arriba y
  // SEASON_TRANSIT, y se comunican como día completo (lastDay). Re-sembrar cada año junto con
  // HOLIDAYS.
  const SEASONS = [
    { key: 'navidad', name: 'Navidad', emoji: '🎄', showFrom: '2026-11-18', lastArrival: '2026-12-23', before: 'antes de Navidad', after: 'después de Navidad', closures: 'No producimos ni las paqueterías entregan el 24, 25 y 31 de diciembre ni el 1 de enero.' },
    { key: 'reyes', name: 'el Día de Reyes', emoji: '👑', showFrom: '2026-12-24', lastArrival: '2027-01-05', before: 'antes del Día de Reyes', after: 'después del Día de Reyes', closures: 'No producimos ni las paqueterías entregan el 24, 25 y 31 de diciembre ni el 1 de enero.' },
    { key: 'sanvalentin', name: 'San Valentín', emoji: '❤️', showFrom: '2027-01-27', lastArrival: '2027-02-12', before: 'antes de San Valentín', after: 'después de San Valentín', closures: 'No producimos ni las paqueterías entregan el lunes 1 de febrero.' }
  ];
  // Promesa de temporada (decisión de Daniel con marketing, oct-2026): mientras hay temporada
  // activa, la fecha que se muestra usa el tránsito típico de la paquetería (regular 4 días
  // hábiles, express 1) en vez del extremo lento de CLASSES (5 y 2). Con eso los cortes que
  // calcula el motor coinciden con los días completos de los anuncios (Navidad 16/21/22-dic,
  // Reyes 27-dic/3-ene/4-ene) y el PDP no se contradice. No aplica a las clases excluidas.
  const SEASON_TRANSIT = { free: 4, express: 1 };
  // Clases sin promesa de temporada: acrílicos (cadena de suministro poco confiable; decisión
  // de Daniel, oct-2026: mejor no prometer nada).
  const SEASON_EXCLUDED = ['_acr-'];

  // Prefijos de CP de la zona "Envío Local GRATIS en Monterrey" del admin
  // (Settings → Shipping and delivery → Local delivery). Mantener en sync con el admin:
  // '64' cubre 64***, '6605' cubre 6605*, etc.
  const LOCAL_CP_PREFIXES = [
    '64',
    '6605', '6606', '6607', '6608', '6609', '661',
    '6635', '6636', '6637', '6638', '6639',
    '662', '664',
    '6660', '6661', '6662', '6663', '6664',
    '671', '6720'
  ];

  // Cutoff del checkout (fulfillment "Same business day", mediodía fijo de Shopify)
  const CUTOFF_HOUR = 12;

  // prodDays: días hábiles de producción antes de embarcar (el EDD del checkout no los
  // modela, por eso PixSets difiere del perfil general). Transits en días hábiles [min, max].
  // localCutoffHour: corte para la promesa de Entrega Local (ausente = sin corte público;
  // el corte real de las 6am de la producción propia no se publicita a propósito).
  //
  // PixSets (flujo con proveedor, ago-2026; productos en draft hasta el relanzamiento —
  // #301): pedidos antes de las 12:00 entran al lote de impresión de esa tarde, llegan al
  // día siguiente y ese mismo día se entregan en MTY; nacional embarca al día siguiente.
  // Acrílicos: el mismo corte de mediodía arranca su reloj local de 10 días hábiles.
  const CLASSES = {
    '_can-': { prodDays: 0, expressTransit: [1, 2], freeTransit: [3, 5], localDays: 1 },
    '_pos-': { prodDays: 0, expressTransit: [1, 2], freeTransit: [3, 5], localDays: 1 },
    '_frm-': { prodDays: 0, expressTransit: [1, 2], freeTransit: [3, 5], localDays: 1 },
    '_kdc-': { prodDays: 0, expressTransit: [1, 2], freeTransit: [3, 5], localDays: 1 },
    '_pix-': { prodDays: 1, expressTransit: [1, 2], freeTransit: [3, 5], localDays: 1, localCutoffHour: 12 },
    '_acr-': { prodDays: 0, expressTransit: [8, 9], freeTransit: [10, 12], localDays: 10, localCutoffHour: 12 }
  };

  // "Ahora" del motor. Para QA de fechas simuladas (temporada, cortes) se puede fijar con
  // ?cl_now=2026-12-16T13:00 en la URL del PDP o del carrito; sin el parámetro es la hora real.
  const currentNow = () => {
    try {
      const match = /[?&]cl_now=([^&#]+)/.exec(window.location.search);
      if (match) {
        const simulated = new Date(decodeURIComponent(match[1]));
        if (!isNaN(simulated.getTime())) {
          return simulated;
        }
      }
    } catch (e) {
      // sin location (tests) o valor inválido: hora real
    }
    return new Date();
  };

  const formatSpanishDate = (date, includeComma = true) => {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const dayName = days[date.getDay()];
    const dayNum = date.getDate();
    const monthName = months[date.getMonth()];
    return includeComma ? `${dayName}, ${dayNum} de ${monthName}` : `${dayName} ${dayNum} de ${monthName}`;
  };

  const isHoliday = (date) => {
    const iso = date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    return HOLIDAYS.indexOf(iso) !== -1;
  };

  const isBusinessDay = (date) => {
    const dayOfWeek = date.getDay();
    return dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday(date);
  };

  const addBusinessDays = (start, days) => {
    const date = new Date(start);
    let remaining = days;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date)) {
        remaining--;
      }
    }
    return date;
  };

  // Día en que el pedido sale rumbo al cliente: hoy si es día hábil y no ha pasado el
  // cutoff; si no, el siguiente día hábil. Espejo del fulfillment del checkout.
  const shipDay = (now) => {
    if (isBusinessDay(now) && now.getHours() < CUTOFF_HOUR) {
      return new Date(now);
    }
    return addBusinessDays(now, 1);
  };

  const classForSku = (sku) => {
    const lowerCaseSku = sku.toLowerCase();
    for (const prefix in CLASSES) {
      if (lowerCaseSku.includes(prefix)) {
        return CLASSES[prefix];
      }
    }
    return CLASSES['_can-']; // sin prefijo conocido: tratar como perfil general
  };

  // Tránsito que se promete por opción: el extremo lento de la clase o, con `typical`, el de
  // SEASON_TRANSIT (el menor de los dos). computeWith no mira la temporada: lo decide compute().
  const computeWith = (sku, now, typical) => {
    const cls = classForSku(sku);
    const base = addBusinessDays(shipDay(now), cls.prodDays);
    const expressTransit = typical.express ? Math.min(cls.expressTransit[1], SEASON_TRANSIT.express) : cls.expressTransit[1];
    const freeTransit = typical.free ? Math.min(cls.freeTransit[1], SEASON_TRANSIT.free) : cls.freeTransit[1];
    return {
      expressDate: addBusinessDays(base, expressTransit),
      freeDate: addBusinessDays(base, freeTransit)
    };
  };

  // Envío nacional. Devuelve null si no hay SKU. `now` inyectable solo para pruebas.
  // Los Date crudos permiten comparar fechas entre líneas del carrito (ej. la express más lejana).
  // En temporada, cada opción promete el tránsito típico sólo hasta su último día comunicado
  // (seasonCutoff); pasado ese día vuelve al tránsito normal, así la fecha del producto dice
  // lo mismo que la línea de temporada ("sólo con express" / "llega después"). El medio día
  // posterior al corte es colchón de producción, no se promete (Daniel, oct-2026).
  const compute = (sku, now) => {
    if (!sku) {
      return null;
    }

    const current = now || currentNow();
    const season = activeSeason(current);
    const inSeason = Boolean(season) && !isSeasonExcluded(sku);
    const dates = computeWith(sku, current, {
      free: inSeason && Boolean(seasonCutoff(sku, 'free', season, current)),
      express: inSeason && Boolean(seasonCutoff(sku, 'express', season, current))
    });
    const expressDate = dates.expressDate;
    const freeDate = dates.freeDate;

    return {
      expressDate: expressDate,
      freeDate: freeDate,
      expressDateText: formatSpanishDate(expressDate, true),
      freeDateText: formatSpanishDate(freeDate, false)
    };
  };

  // Entrega Local MTY: N días hábiles desde hoy. Sin cutoff público para las clases de
  // producción propia (el corte real de las 6am no se publicita); las clases con
  // localCutoffHour (PixSets, Acrílicos) corren su reloj desde el siguiente día hábil
  // cuando el pedido cae después del corte o en día inhábil (entran al lote siguiente).
  const computeLocal = (sku, now) => {
    if (!sku) {
      return null;
    }

    const cls = classForSku(sku);
    const current = now || currentNow();

    let base = new Date(current);
    if (cls.localCutoffHour != null && (!isBusinessDay(base) || base.getHours() >= cls.localCutoffHour)) {
      base = addBusinessDays(base, 1);
    }
    const localDate = addBusinessDays(base, cls.localDays);

    // "mañana" solo cuando de verdad es el día calendario siguiente (un viernes en la
    // noche el siguiente día hábil es lunes y el copy no puede decir "mañana")
    const tomorrow = new Date(current);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const isTomorrow = localDate.getFullYear() === tomorrow.getFullYear() &&
      localDate.getMonth() === tomorrow.getMonth() &&
      localDate.getDate() === tomorrow.getDate();

    // El día de la semana en minúsculas permite el copy corto estilo Amazon/ML
    // ("recíbelo el lunes"): la entrega local nunca está a más de unos días, así que
    // el nombre del día solo es siempre inequívoco.
    const weekdaysLower = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

    return {
      localDate: localDate,
      localDateText: formatSpanishDate(localDate, true),
      localDateTextPlain: formatSpanishDate(localDate, false),
      localWeekday: weekdaysLower[localDate.getDay()],
      isTomorrow: isTomorrow,
      isNextBusinessDay: cls.localDays === 1
    };
  };

  const normalizeCP = (value) => (value || '').replace(/\D/g, '').slice(0, 5);

  const isLocalCP = (value) => {
    const cp = normalizeCP(value);
    if (cp.length !== 5) {
      return false;
    }
    return LOCAL_CP_PREFIXES.some((prefix) => cp.indexOf(prefix) === 0);
  };

  // localStorage puede lanzar (Safari privado, storage deshabilitado): degradar a "sin CP"
  const CP_STORAGE_KEY = 'cl:delivery-cp';

  const getStoredCP = () => {
    try {
      return window.localStorage.getItem(CP_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  };

  const setStoredCP = (value) => {
    try {
      const cp = normalizeCP(value);
      if (cp) {
        window.localStorage.setItem(CP_STORAGE_KEY, cp);
      } else {
        window.localStorage.removeItem(CP_STORAGE_KEY);
      }
    } catch (e) {
      // sin storage: el estado simplemente no persiste entre páginas
    }
  };

  // ---------- Temporada (#410)
  const parseISODate = (iso) => {
    const parts = iso.split('-');
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  };
  const dayStart = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const endOfDay = (iso) => {
    const d = parseISODate(iso);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  // Temporada activa para la fecha dada (o ninguna)
  const activeSeason = (now) => {
    const today = dayStart(now || currentNow());
    for (let i = 0; i < SEASONS.length; i++) {
      const season = SEASONS[i];
      if (today >= parseISODate(season.showFrom) && today <= parseISODate(season.lastArrival)) {
        return season;
      }
    }
    return null;
  };

  const isSeasonExcluded = (sku) => {
    const lowerCaseSku = (sku || '').toLowerCase();
    return SEASON_EXCLUDED.some((prefix) => lowerCaseSku.includes(prefix));
  };

  // Llegada de un pedido hecho en `at` con la promesa de temporada (tránsito típico en las
  // opciones nacionales). Sólo lo usa seasonCutoff; nunca llama a compute() (sería circular).
  const arrivalFor = (sku, option, at) => {
    if (option === 'local') {
      const local = computeLocal(sku, at);
      return local ? local.localDate : null;
    }
    if (!sku) {
      return null;
    }
    const national = computeWith(sku, at, { free: true, express: true });
    return option === 'express' ? national.expressDate : national.freeDate;
  };

  // Último día para pedir (pagando antes del corte de mediodía) y recibir dentro de la
  // temporada. hourMatters indica si pedir después de las 12:00 de ese día ya no alcanza
  // (la Entrega Local de producción propia no tiene corte público: llega igual).
  // lastDay = último día COMPLETO para pedir (con corte a mediodía, el día anterior): es lo
  // que se comunica, igual que en los anuncios, sin hora. Devuelve null si ya pasó: la mañana
  // del día del corte es colchón de producción y no se promete.
  const seasonCutoff = (sku, option, season, now) => {
    const limit = endOfDay(season.lastArrival);
    const cursorStart = dayStart(now || currentNow());
    const cursor = new Date(cursorStart);
    let best = null;
    while (cursor <= limit) {
      const at = new Date(cursor);
      at.setHours(11, 0, 0, 0);
      const arrival = arrivalFor(sku, option, at);
      if (arrival && arrival <= limit) {
        best = new Date(cursor);
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    if (!best) {
      return null;
    }
    const afterNoon = new Date(best);
    afterNoon.setHours(13, 0, 0, 0);
    const lateArrival = arrivalFor(sku, option, afterNoon);
    const hourMatters = !lateArrival || lateArrival > limit;
    const lastDay = new Date(best);
    if (hourMatters) {
      lastDay.setDate(lastDay.getDate() - 1);
    }
    if (lastDay < cursorStart) {
      return null; // el último día comunicado ya pasó: la mañana del día del corte no se promete
    }
    return {
      day: best,
      dayText: formatSpanishDate(best, false),
      hourMatters: hourMatters,
      lastDay: lastDay,
      lastDayText: formatSpanishDate(lastDay, false)
    };
  };

  // Estado de temporada para un SKU en este momento: por opción, si todavía llega a tiempo
  // (con la hora real del pedido) y cuál es el último día para pedir. null si no hay temporada
  // activa, la clase está excluida o no hay SKU.
  const seasonStatus = (sku, now) => {
    const current = now || currentNow();
    const season = activeSeason(current);
    if (!season || !sku || isSeasonExcluded(sku)) {
      return null;
    }
    const limit = endOfDay(season.lastArrival);
    const status = { season: season };
    ['free', 'express', 'local'].forEach((option) => {
      const cutoff = seasonCutoff(sku, option, season, current);
      // Nacional: a tiempo sólo hasta el último día comunicado (compute() promete igual).
      // Local: por llegada real, porque la fecha local no cambia con la temporada.
      let ok = Boolean(cutoff);
      if (option === 'local') {
        const arrival = arrivalFor(sku, 'local', current);
        ok = Boolean(arrival && arrival <= limit);
      }
      status[option] = { ok: ok, cutoff: cutoff };
    });
    return status;
  };

  // Línea de temporada del PDP. mode: 'local' (C.P. en zona) o 'national'. isCustomProduct se
  // conserva por compatibilidad (la liga de personalizados ya es permanente y vive en el Liquid).
  // Devuelve { html, late } o null si no hay nada que decir. El último día comunicado lleva
  // la etiqueta "ÚLTIMO DÍA" al frente (urgencia clara, decisión de Daniel oct-2026); los
  // demás días, "Pide a más tardar el <día>" sin hora.
  const seasonLine = (sku, mode, isCustomProduct, now) => {
    const current = now || currentNow();
    const status = seasonStatus(sku, current);
    if (!status) {
      return null;
    }
    const season = status.season;
    const lead = season.emoji + ' ';
    // isCustomProduct ya no cambia el texto: la liga "Consideraciones para pedidos personalizados"
    // vive permanente al pie del aviso (snippets/product-info.liquid). Se conserva en la firma.
    const caveat = '';
    const today = dayStart(current).getTime();
    // Sin corte vigente pero a tiempo (sólo local con corte a mediodía, la mañana siguiente al
    // último día completo): también es el último momento, se dice ÚLTIMO DÍA
    const isLastDay = (option) => !option.cutoff || dayStart(option.cutoff.lastDay).getTime() === today;
    const orderBy = (option) => ' Pide a más tardar el <b>' + option.cutoff.lastDayText + '</b>.';
    const late = { html: 'Llega ' + season.after + '.', late: true };
    if (mode === 'local') {
      if (!status.local.ok) {
        return late;
      }
      return isLastDay(status.local)
        ? { html: lead + '<b>ÚLTIMO DÍA</b>: pide hoy y llega <b>' + season.before + '</b> con tu Entrega Local.' + caveat, late: false }
        : { html: lead + 'Llega <b>' + season.before + '</b> con tu Entrega Local.' + orderBy(status.local) + caveat, late: false };
    }
    if (status.free.ok) {
      return isLastDay(status.free)
        ? { html: lead + '<b>ÚLTIMO DÍA</b>: pide hoy y llega <b>' + season.before + '</b> con envío GRATIS.' + caveat, late: false }
        : { html: lead + 'Llega <b>' + season.before + '</b> con envío GRATIS.' + orderBy(status.free) + caveat, late: false };
    }
    if (status.express.ok) {
      return isLastDay(status.express)
        ? { html: lead + '<b>ÚLTIMO DÍA</b>: pide hoy <b>con envío express</b> y llega ' + season.before + '. Elígelo al pagar.' + caveat, late: false }
        : { html: lead + season.before.charAt(0).toUpperCase() + season.before.slice(1) + ' <b>sólo con envío express</b>: elígelo al pagar.' + orderBy(status.express) + caveat, late: false };
    }
    return late;
  };

  return {
    compute: compute,
    computeLocal: computeLocal,
    activeSeason: activeSeason,
    seasonStatus: seasonStatus,
    seasonLine: seasonLine,
    isSeasonExcluded: isSeasonExcluded,
    formatSpanishDate: formatSpanishDate,
    parseISODate: parseISODate,
    currentNow: currentNow,
    normalizeCP: normalizeCP,
    isLocalCP: isLocalCP,
    getStoredCP: getStoredCP,
    setStoredCP: setStoredCP
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  /* Wiring del delivery notice del PDP: nacional / Entrega Local MTY / captura de C.P. */

  try {
    const deliveryNotice = document.getElementById('delivery_notice');

    // El archivo también se carga en el carrito (#232); sin #delivery_notice no hay wiring de PDP que hacer.
    if (!deliveryNotice) {
      return;
    }

    const productSection = document.querySelector('[data-section-type="product"]');
    const productJsonElement = document.querySelector('[data-product-json]');

    if (!productSection) {
      console.warn("Product section with attribute 'data-section-type=\"product\"' not found. Estimator cannot listen for variant changes.");
      return;
    }
    if (!productJsonElement) {
      console.error("Product JSON element with attribute 'data-product-json' not found. Estimator cannot get initial SKU.");
      return;
    }

    const localBlock = deliveryNotice.querySelector('[data-delivery-local]');
    const nationalBlock = deliveryNotice.querySelector('[data-delivery-national]');
    const teaser = deliveryNotice.querySelector('[data-mty-teaser]');
    const teaserText = deliveryNotice.querySelector('[data-mty-teaser-text]');
    const otherCp = deliveryNotice.querySelector('[data-other-cp]');
    const cpForm = deliveryNotice.querySelector('[data-cp-form]');
    const cpInput = deliveryNotice.querySelector('[data-cp-input]');
    const cpError = deliveryNotice.querySelector('[data-cp-error]');
    const seasonElement = deliveryNotice.querySelector('[data-season]');
    const isCustomProduct = deliveryNotice.getAttribute('data-custom-product') === 'true';

    // Línea de temporada (#410): arriba de las fechas, según el modo (local/nacional)
    const renderSeason = (mode) => {
      if (!seasonElement || !window.DeliveryDateCalculator.seasonLine) {
        return;
      }
      const line = window.DeliveryDateCalculator.seasonLine(currentSku, mode, isCustomProduct);
      if (!line) {
        seasonElement.hidden = true;
        return;
      }
      seasonElement.innerHTML = line.html;
      seasonElement.classList.toggle('delivery-notice__season--late', line.late);
      seasonElement.hidden = false;
    };

    let currentSku = null;

    const render = () => {
      try {
        const calc = window.DeliveryDateCalculator;
        const dates = calc.compute(currentSku);

        if (!dates) {
          deliveryNotice.style.display = 'none';
          return;
        }
        deliveryNotice.style.display = 'block';

        const local = calc.computeLocal(currentSku);
        const cp = calc.getStoredCP();
        const isLocal = cp !== '' && calc.isLocalCP(cp);

        const freeDateElement = deliveryNotice.querySelector('.delivery-date-free');
        const expressDateElement = deliveryNotice.querySelector('.delivery-date-text');

        if (freeDateElement) {
          freeDateElement.textContent = dates.freeDateText;
        }
        if (expressDateElement) {
          expressDateElement.textContent = dates.expressDateText;
        }

        renderSeason(isLocal ? 'local' : 'national');

        if (isLocal && localBlock) {
          localBlock.hidden = false;
          if (nationalBlock) {
            nationalBlock.hidden = true;
          }

          const promise = localBlock.querySelector('[data-local-promise]');
          if (promise) {
            promise.innerHTML = local.isTomorrow
              ? 'Pide hoy y recíbelo <b>GRATIS mañana</b>, <b>' + local.localDateTextPlain + '</b>'
              : 'Pide hoy y recíbelo <b>GRATIS</b> el <b>' + local.localDateText + '</b>';
          }

          const cpLabel = localBlock.querySelector('[data-local-cp]');
          if (cpLabel) {
            cpLabel.textContent = cp;
          }
          return;
        }

        if (localBlock) {
          localBlock.hidden = true;
        }
        if (nationalBlock) {
          nationalBlock.hidden = false;
        }

        if (cp !== '') {
          // CP fuera de la zona local: fechas nacionales + recordatorio del CP capturado
          if (teaser) {
            teaser.hidden = true;
          }
          if (otherCp) {
            otherCp.hidden = false;
            const cpLabel = otherCp.querySelector('[data-national-cp]');
            if (cpLabel) {
              cpLabel.textContent = cp;
            }
          }
        } else {
          if (otherCp) {
            otherCp.hidden = true;
          }
          if (teaser) {
            teaser.hidden = false;
            if (teaserText && local) {
              if (local.isNextBusinessDay) {
                // "mañana" solo cuando es literal; si no (viernes, vísperas de festivo),
                // el día de la semana solo — cercano, preciso y sin fecha larga
                teaserText.innerHTML = local.isTomorrow
                  ? '📍 ¿Estás en Monterrey? Recíbelo <b>mañana</b>'
                  : '📍 ¿Estás en Monterrey? Recíbelo el <b>' + local.localWeekday + '</b>';
              } else {
                // PixSets/Acrílicos: la fecha local puede empatar con la express (pagada),
                // así que el gancho es el diferenciador real: llega antes que el envío
                // gratis nacional, y sigue siendo gratis.
                const daysEarlier = Math.round((dates.freeDate - local.localDate) / 86400000);
                teaserText.innerHTML = daysEarlier >= 2
                  ? '📍 ¿Estás en Monterrey? Recíbelo <b>GRATIS ' + daysEarlier + ' días antes</b>'
                  : '📍 ¿Estás en Monterrey? Recíbelo <b>GRATIS</b> el <b>' + local.localDateTextPlain + '</b>';
              }
            }
          }
        }
      } catch (e) {
        console.error('Error during delivery date calculation:', e);
        deliveryNotice.style.display = 'none';
      }
    };

    const openCpForm = () => {
      if (!cpForm) {
        return;
      }
      cpForm.hidden = false;
      if (cpError) {
        cpError.hidden = true;
      }
      if (cpInput) {
        cpInput.value = window.DeliveryDateCalculator.getStoredCP();
        cpInput.focus();
      }
    };

    deliveryNotice.addEventListener('click', function(event) {
      const target = event.target;
      if (target.closest('[data-cp-open]') || target.closest('[data-cp-change]')) {
        openCpForm();
      }
    });

    // El capturador de CP es un div dentro del form de producto (un <form> anidado lo
    // elimina el parser), así que el "submit" es un botón + Enter manejado a mano.
    const submitCp = () => {
      const calc = window.DeliveryDateCalculator;
      const cp = calc.normalizeCP(cpInput ? cpInput.value : '');

      // Campo vacío = borrar el CP guardado y volver al estado default
      if (cp.length !== 0 && cp.length !== 5) {
        if (cpError) {
          cpError.hidden = false;
        }
        return;
      }

      calc.setStoredCP(cp);
      if (cpForm) {
        cpForm.hidden = true;
      }
      if (cpError) {
        cpError.hidden = true;
      }
      render();
      // Aviso para otros consumidores (ej. carrito con re-render AJAX en el futuro)
      document.dispatchEvent(new CustomEvent('deliverycp:changed', { detail: { cp: cp } }));
    };

    const cpSubmit = deliveryNotice.querySelector('[data-cp-submit]');
    if (cpSubmit) {
      cpSubmit.addEventListener('click', submitCp);
    }
    if (cpInput) {
      cpInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault(); // no disparar el add-to-cart del form de producto
          submitCp();
        }
      });
    }

    // --- Listen for variant changes ---
    productSection.addEventListener('variant:changed', function(event) {
      if (event.detail.variant && event.detail.variant.sku) {
        currentSku = event.detail.variant.sku;
        render();
      }
    });

    // --- Initial calculation on page load ---
    let productData;
    try {
      productData = JSON.parse(productJsonElement.textContent);
    } catch(e) {
      console.error('Failed to parse product JSON for delivery estimator:', e);
      return;
    }

    // Use the selected_variant_id from the JSON, which works for all product types.
    if (productData && productData.selected_variant_id) {
      const initialVariantId = productData.selected_variant_id;
      const productObj = window.globalProductJson || productData.product;

      if (productObj && productObj.variants) {
        const initialVariant = productObj.variants.find(v => v.id === initialVariantId);

        if (initialVariant && initialVariant.sku) {
          currentSku = initialVariant.sku;
          render();
        }
      }
    }

  } catch (e) {
    console.error('An unexpected error occurred while initializing the delivery date calculator:', e);
  }
});
